import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface UpdateLeadDecisionsRequest {
  polygonDecision?: Record<string, unknown> | null;
  landlordDecision?: Record<string, unknown> | null;
  tenantDecision?: Record<string, unknown> | null;
  ownerOccupier?: boolean;
}

export interface UpdateLeadDecisionsResponse {
  lead: Lead;
}

const patchLeadDecisions = async (
  authToken: string,
  leadId: string,
  body: UpdateLeadDecisionsRequest
): Promise<UpdateLeadDecisionsResponse> => {
  const { data } = await axiosConfig.patch(
    `/leads/${leadId}/decisions`,
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default patchLeadDecisions;
